import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'Inteligencia Artificial',
  title: 'IA y Agentes Inteligentes para tu empresa.',
  subtitle:
    'Diseñamos agentes de IA que se integran con las herramientas y procesos de tu organización para consultar información, automatizar tareas, asistir equipos y ejecutar acciones reales.',
  tags: [
    'Agentes IA',
    'RAG',
    'Automatización',
    'IA conectada a ERP',
    'LLMs',
    'Bases de conocimiento',
  ],
  blocks: [
    {
      icon: 'ri-robot-2-line',
      title: 'Agentes IA empresariales',
      desc: 'Agentes que trabajan dentro de tus procesos, no solo chatbots que responden preguntas.',
      items: ['Agentes comerciales', 'Agentes de soporte', 'Agentes operacionales'],
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Asistentes internos',
      desc: 'Asistentes que consultan tu información y apoyan a tus equipos en el día a día.',
      items: ['Consultas sobre documentos', 'Acceso a conocimiento interno', 'Soporte a equipos'],
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Automatización mediante IA',
      desc: 'Convertimos tareas repetitivas en flujos automáticos impulsados por inteligencia artificial.',
    },
    {
      icon: 'ri-database-2-line',
      title: 'IA conectada a ERP',
      desc: 'Conectamos la IA con SAP Business One y otros sistemas para consultar stock, clientes y pedidos.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'RAG y bases de conocimiento',
      desc: 'Sistemas de recuperación aumentada para que la IA responda con base en tus datos reales.',
      items: ['Vector databases', 'Embeddings', 'Fuentes propias'],
    },
    {
      icon: 'ri-brain-line',
      title: 'Integración con LLMs',
      desc: 'Integramos los modelos de lenguaje más adecuados para cada caso de uso, con costos controlados.',
    },
  ],
  highlightTitle: 'Una IA aislada responde preguntas. Una IA conectada trabaja.',
  highlightDesc:
    'En ACOMA conectamos la inteligencia artificial con tus sistemas y datos reales para que genere valor operativo, no solo respuestas.',
};

export default function InteligenciaArtificial() {
  return <ServicePage content={content} />;
}